<template>
  <v-data-table
    :headers="headers"
    :items="groups"
    :search="search"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-alert :value="true" dense outlined type="error" v-if="error">
        {{ error }}
      </v-alert>
      <v-alert :value="true" dense outlined type="success" v-if="message">
        {{ message }}
      </v-alert>
      <v-toolbar flat>
        <v-toolbar-title>Ryhmät</v-toolbar-title>

        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          label="Hae..."
          class="mx-4"
        ></v-text-field>
        <v-dialog v-model="dialog" max-width="750px">
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      v-model="groupItems.groupName"
                      :label="$t('editGroup.groupName')"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-autocomplete
                      prepend-icon="mdi-account-supervisor"
                      v-model="groupItems.groupState"
                      :items="states"
                      :label="$t('editGroup.groupState')"
                      :placeholder="$t('editGroup.groupAutoCompleteChoise')"
                      item-text="name"
                      item-value="value"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">
                Cancel
              </v-btn>
              <v-btn color="blue darken-1" text @click="save">
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>

    <template v-slot:[`item.actions`]="{ item }">
      <v-icon small class="mr-2" @click="editItem(item)">
        mdi-pencil
      </v-icon>
    </template>
  </v-data-table>
</template>
<script>
import GroupService from '@/services/GroupService.js';

export default {
  data() {
    return {
      groups: [],
      dialog: false,
      error: null,
      message: null,
      search: '',
      formTitle: 'Muokkaa ryhmän tietoja',
      headers: [
        { text: this.$t('showGroups.groupName'), value: 'groupName' },
        { text: this.$t('showGroups.groupState'), value: 'groupState' },
        {
          text: this.$t('showGroups.groupActions'),
          value: 'actions',
          sortable: false,
        },
      ],
      states: [
        {
          name: this.$t('editGroup.groupStateItems.active'),
          value: 'Aktiivinen',
        },
        {
          name: this.$t('editGroup.groupStateItems.passive'),
          value: 'Passiivinen',
        },
      ],
      groupItems: {
        groupName: '',
        groupState: '',
      },
    };
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  async created() {
    const response = await GroupService.getAllGroups();
    this.groups = response.data.groups;
  },

  methods: {
    editItem(item) {
      this.groupItems = Object.assign({}, item);
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.groupItems = Object.assign({}, this.groups);
      });
    },

    async save() {
      try {
        const response = await GroupService.saveGroupModification(
          this.groupItems
        );
        this.message = response.data.message;
        this.error = response.data.error;
        const groups = await GroupService.getAllGroups();
        this.groups = groups.data.groups;
        this.close();
        setTimeout(() => {
          this.message = null;
          this.error = null;
        }, 3000);
      } catch (error) {
        this.close();
        this.error = 'Jokin meni vikaan';
        setTimeout(() => {
          this.error = null;
        });
      }
    },
  },
};
</script>
<style></style>
